// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
// @ commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class CancelCreditCardRenewalErrorStep extends React.Component {
    constructor(props) {
        super(props);
        this.goBackHandler = this.goBackHandler.bind(this);
    }

    goBackHandler() {
        this.props.history.push('/myprofile/cards');
    }

    render() {
        const title = formatText('cancelCreditCardRenewal-errorTitle');
        const errorSubTitle = formatText('cancelCreditCardRenewal-errorSubTitle');
        const goBackButtonLabel = formatText('cancelCreditCardRenewal-goBackButton').toUpperCase();

        return (
            <article className="card-pin-request-error row no-gutter">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    subtitle={errorSubTitle}
                    textLink={goBackButtonLabel}
                    goBackHandler={this.goBackHandler}
                />
            </article>
        )
    }
}

CancelCreditCardRenewalErrorStep.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(CancelCreditCardRenewalErrorStep);
